import SwiperComponent from '@/js/core/SwiperComponent'
import Swiper from 'swiper'

export default class MediaGallery extends SwiperComponent {
  static root = '[data-media-gallery]'

  addSwiper () {
    const { 
      swiperContainer,
      swiperPagination,
      swiperButtonPrev,
      swiperButtonNext,
    } = this.$els

    this.swiper = new Swiper(swiperContainer, {
      navigation: {
        prevEl: swiperButtonPrev,
        nextEl: swiperButtonNext,
      },
      pagination: {
        el: swiperPagination,
        clickable: true,
        type: 'bullets',
      },
      keyboard: {
        enabled: true,
      }
    })
  }
}